import { render, staticRenderFns } from "./UIHorizontalTable.vue?vue&type=template&id=459f0d72&scoped=true"
import script from "./UIHorizontalTable.vue?vue&type=script&lang=js"
export * from "./UIHorizontalTable.vue?vue&type=script&lang=js"
import style0 from "./UIHorizontalTable.vue?vue&type=style&index=0&id=459f0d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f0d72",
  null
  
)

export default component.exports